<template>
    <div class="d-flex flex-row gap-2">
        <div class="text-end">
            <BatteryLevelIcon :battery-level="props.value"></BatteryLevelIcon>
        </div>
        <div class="text-end w-50">
            <span
                v-if="value"
                class="me-4"
                >{{ value }}%</span
            >
        </div>
    </div>
</template>

<script setup lang="ts">
import { BatteryLevelIcon } from '..';

const props = defineProps<{
    /**
     * The battery level in percent
     */
    value: number | null;
}>();
</script>
